import { SelectorType } from "@redotech/redo-model/conversion/storefront-delivery-estimate";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const removeStorefrontDeliveryEstimateSelector = {
  name: "removeStorefrontDeliveryEstimateSelector" as const,
  input: z.object({
    selectorId: zExt.objectId(),
    selectorType: createEnum(SelectorType),
  }),
  output: z.null(),
};
